import { Card, type CardProps, mergeSxProps } from "@src/appV2/redesign/system/ui-components";

import { isRebrandingEnabled } from "../../system/ui-theme";

interface ShiftCardWrapperProps extends CardProps {
  isUrgent?: boolean;
  isBundle?: boolean;
  isDouble?: boolean;
}

export function ShiftCardWrapper(props: ShiftCardWrapperProps) {
  const {
    isUrgent = false,
    isBundle = false,
    isDouble = false,
    variant = "quaternary",
    outlined = true,
    sx,
    ...restProps
  } = props;

  return (
    <Card
      variant={variant}
      outlined={isUrgent || isBundle || isDouble || outlined}
      sx={mergeSxProps(
        (theme) => ({
          minHeight: theme.size?.shiftCard.minHeight,
          borderColor: (theme) => {
            if (isUrgent) {
              return theme.palette.shift?.urgent.border;
            }
            if (isBundle) {
              return theme.palette.shift?.bundle?.border;
            }
            if (isDouble) {
              return theme.palette.shift?.double?.border;
            }
            return undefined;
          },
          ...((isUrgent || isBundle || isDouble) &&
            isRebrandingEnabled() && {
              borderWidth: theme.borderWidth.thick,
            }),
        }),
        sx
      )}
      {...restProps}
    />
  );
}
